const LandingPagePreference = {
	Community: 'Community',
	EdelweissPlus: 'EdelweissPlus',
};

const LandingPageCookieName = 'treeline.landingpage';

const getLandingPageCookie = function(landingPage) {
	const hostname = window.location.hostname;
	const hostnameComponents = hostname.split('.');

	let domain = hostname;
	if (hostnameComponents.length > 2) {
		const length = hostnameComponents.length;
		domain =
			'.' +
			hostnameComponents[length - 2] +
			'.' +
			hostnameComponents[length - 1];
	}

	const expirationDate = new Date();
	expirationDate.setHours(expirationDate.getHours() + 1);
	return {
		name: LandingPageCookieName,
		value: landingPage,
		options: {
			domain: domain,
			expires: expirationDate,
			sameSite: 'Strict',
		},
	};
};

export default LandingPagePreference;
export { getLandingPageCookie, LandingPageCookieName };
